import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, Form, Input, InputNumber, Space, message, Popconfirm } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../utils/api';
import { useMenuPermission } from '../hooks/useMenuPermission';

function GrowthMethodManage() {
  const { canEdit } = useMenuPermission();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const res = await api.get('/growth-methods');
      if (res.code === 200) setData(res.data);
    } catch (err) {}
    setLoading(false);
  };

  const handleAdd = () => {
    setEditingItem(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setEditingItem(record);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      let res;
      if (editingItem) {
        res = await api.put(`/growth-methods/${editingItem.id}`, values);
      } else {
        res = await api.post('/growth-methods', values);
      }
      if (res.code === 200) {
        message.success(editingItem ? '更新成功' : '创建成功');
        setModalVisible(false);
        loadData();
      }
    } catch (err) {}
  };

  const handleDelete = async (id) => {
    try {
      const res = await api.delete(`/growth-methods/${id}`);
      if (res.code === 200) {
        message.success('删除成功');
        loadData();
      }
    } catch (err) {}
  };

  const columns = [
    { title: 'ID', dataIndex: 'id', width: 80 },
    { title: '涨粉方式', dataIndex: 'name' },
    { title: '参考价格', dataIndex: 'price', width: 120, render: v => v ? `¥${v}` : '-' },
    { title: '实际价格', dataIndex: 'reference_price', width: 120, render: v => v ? `¥${v}` : '-' },
    { title: '最终有效粉要求', dataIndex: 'effective_fans_threshold', width: 140, render: v => (v === null || v === undefined || v === '') ? '无要求' : v },
    { title: '涨粉量要求', dataIndex: 'growth_target', width: 120, render: v => (v === null || v === undefined || v === '') ? '无要求' : v },
    {
      title: '创建时间', dataIndex: 'created_at', width: 180,
      render: v => v ? new Date(v).toLocaleString() : '-'
    },
    {
      title: '操作', key: 'action', width: 150,
      render: (_, record) => (
        <Space>
          {canEdit && <Button type="link" size="small" icon={<EditOutlined />} onClick={() => handleEdit(record)}>编辑</Button>}
          {canEdit && (
            <Popconfirm title="确定删除？" onConfirm={() => handleDelete(record.id)}>
              <Button type="link" size="small" danger icon={<DeleteOutlined />}>删除</Button>
            </Popconfirm>
          )}
        </Space>
      )
    }
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between' }}>
        <h3>涨粉方式管理</h3>
        {canEdit && <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>新增涨粉方式</Button>}
      </div>

      <Table
        rowKey="id"
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={false}
      />

      <Modal
        title={editingItem ? '编辑涨粉方式' : '新增涨粉方式'}
        open={modalVisible}
        onOk={handleSave}
        onCancel={() => setModalVisible(false)}
        width={400}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="name" label="涨粉方式名称" rules={[{ required: true, message: '请输入涨粉方式名称' }]}>
            <Input placeholder="例如：抖音抖+、抖音自热" />
          </Form.Item>
          <Form.Item name="price" label="参考价格">
            <InputNumber style={{ width: '100%' }} min={0} precision={2} prefix="¥" placeholder="输入参考价格" />
          </Form.Item>
          <Form.Item name="reference_price" label="实际价格">
            <InputNumber style={{ width: '100%' }} min={0} precision={2} prefix="¥" placeholder="输入实际价格" />
          </Form.Item>
          <Form.Item name="effective_fans_threshold" label="最终有效粉要求" extra="留空表示该涨粉方式不要求最终有效粉">
            <InputNumber style={{ width: '100%' }} min={0} precision={0} placeholder="例如 500；留空=不要求" />
          </Form.Item>
          <Form.Item name="growth_target" label="涨粉量要求" extra="用于涨粉监控的「目标」和「剩余进度」，留空表示不要求">
            <InputNumber style={{ width: '100%' }} min={0} precision={0} placeholder="例如 500；留空=不要求" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default GrowthMethodManage;
